import { useAuth0 } from "@auth0/auth0-react";
import { API_BASE } from "../../../apiBase";
import { useEffect, useState } from "react";
import { utils, writeFile } from 'xlsx';
import { checkGatedBatch } from "../../../utils";

function ModalForProFeatures(props) {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(true);
  const [manualRender, setManualRender] = useState(15);
  const [loadingExport, setLoadingExport] = useState(false);

  useEffect(() => {
    const isPro = async () => {
      const accessToken = await getAccessTokenSilently();
      fetch(API_BASE + "/is_pro", {
        mode: "cors",
        headers: { Authorization: `Bearer ${accessToken}` },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setLoading(false)
          } else {
            alert("Only Pro & Master Plan subscribers can access the Pro Features!")
          }
        }).catch((error) => {
          alert("Error! Please try again.");
          setLoading(false)
        });
    };

    if (!isLoading && isAuthenticated && props.proModalOpen) {
      isPro()
    }
  }, [props.proModalOpen, isAuthenticated, isLoading, getAccessTokenSilently]);

  const exportToExcel = async () => {
    let fullGatedStatuses = props.gatedStatus ?? {};

    if (props.data && props.data.length > 0 && props.sellerId && props.sellerId !== "none") {
      const asinsToCheck = [];
      props.data.forEach(prd => {
        const asin = prd.asin.split("/")[prd.asin.split("/").length - 1];
        if (!props.gatedStatus.hasOwnProperty(asin)) {
          asinsToCheck.push(asin);
        }
      });

      if (asinsToCheck.length > 0) {
        setLoadingExport(true);
        const gatedStatuses = await checkGatedBatch(props.sellerId, asinsToCheck, props.refreshToken);
        if (gatedStatuses) {
          fullGatedStatuses = {
            ...fullGatedStatuses,
            ...gatedStatuses
          }

          if (props.setGatedStatus) {
            Object.entries(gatedStatuses).forEach(([asin, response]) => {
              props.setGatedStatus((prevGS) => ({
                ...prevGS,
                [asin]: response,
              }));
            });
          }
        }
        setLoadingExport(false)
      }
    }

    let formedData = []
    props.data.forEach(product => {
      formedData.push({
        "Image": `=IMAGE("${product.az_img}")`,
        "Name": '="' + (product.title.split(" | At Source")[0].replaceAll('"', "''")) + '"',
        "Amazon Link": product.asin,
        "ASIN": product.asin.split("/")[product.asin.split("/").length - 1],
        "Supplier": product.source_name,
        "Supplier Link": product.url.replace("X".repeat(product.source_name.length), product.source_name),
        "UPC": '="' + (product.upc) + '"',
        "Category": product.category,
        "BSR": product.sales_rank,
        "AZ Offers": 0,
        "Supplier Price": product.price,
        "AZ Price": "OOS",
        "FBA Cost": "N/A",
        "AZ Referral Fee": "N/A",
        "Additional Costs": parseFloat(localStorage.getItem("costPrep") ?? 0),
        "Profit": "N/A",
        "ROI": "N/A",
        "Gated Status": (fullGatedStatuses.hasOwnProperty(product.asin.split("/")[product.asin.split("/").length - 1]) && fullGatedStatuses[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions ? (fullGatedStatuses[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions.length === 0 ? "Ungated" : (fullGatedStatuses[product.asin.split("/")[product.asin.split("/").length - 1]].restrictions[0].reasons[0].reasonCode === "APPROVAL_REQUIRED" ? "Approval Required" : "Gated")) : "Gated status must appear in the table for export"),
      })
    });
    const ws = utils.json_to_sheet(formedData);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Sheet 1');
    writeFile(wb, 'Nepeto.csv');
  };

  return (!loading &&
    <div
      id="modal-js-example"
      className={"modal" + (props.proModalOpen ? " is-active" : "")}
    >
      <div className="modal-background" onClick={() => {
        props.setProModalOpen(false);
      }}></div>

      <div
        className="modal-content"
        style={{ width: props.isMobile ? "90vw" : "24vw" }}
      >
        <div className="box">
          <p style={{ fontSize: props.isMobile ? "2.5vh" : "1.1vw" }}>
            Pro Features
          </p>
          <br />
          <button
            className={"button is-rounded" + (!localStorage.getItem("clickedActions") ? " hidebtnglow" : "")}
            style={{
              backgroundColor: "#8B3C7E",
              color: "white",
              fontWeight: "700",
              border: "#8B3C7E",
              fontSize: props.isMobile ? "2.2vh" : "1vw",
            }}
            disabled={loadingExport}
            onClick={() => {
              exportToExcel()
            }}
          >
            {loadingExport ? <>
              Loading...
            </> : <>
              Export &nbsp;<i class="fa fa-download" style={{ paddingTop: "5px" }} aria-hidden="true"></i>
            </>}
          </button>
          <br /><br />
          <label class="checkbox" style={{ fontSize: "150%" }}>
            <input
              type="checkbox"
              style={{ transform: "scale(1.5)" }}
              onChange={(e) =>
                props.setFilters((filters) => ({
                  ...filters,
                  favoritesOnly: +e.target.checked,
                }))
              }
              checked={props.filters.favoritesOnly || false}
            />
            &nbsp;&thinsp;Show only Favorites
          </label>
          <br />
          <br />
          {!props.oos && <button
            className="button is-rounded lightbutton"
            onClick={() => { props.setModalSetting("profit"); props.setProModalOpen(false); }}
            style={{
              width: "57%",
              border:
                props.filters &&
                props.filters.hasOwnProperty("profit") &&
                "3px solid rgb(72,199,142)",
            }}
          >
            Filter By Profit
          </button>}
          <br /><br />
          {!props.oos && <button
            className={"button is-rounded" + (!localStorage.getItem("clickedActions") ? " hidebtnglow" : "")}
            style={{
              backgroundColor: "#8B3C7E",
              color: "white",
              fontWeight: "700",
              border:
                props.filters &&
                JSON.stringify(props.filters).includes("found_time") &&
                "3px solid rgb(72,199,142)",
              fontSize: props.isMobile ? "2.2vh" : "1vw",
            }}
            onClick={() => {
              props.setFilters((filters) => ({
                ...filters,
                sortBy: ["found_time", true],
              }));
              props.setProModalOpen(false);
            }}
          >
            Sort by 'Found time' - Newest First
          </button>}
          {!props.oos && <br />}
          {!props.oos && <br />}
          {!props.oos &&
            <div style={{ border: "1px solid gray", paddingTop: "15px", paddingBottom: "15px" }}>
              <div style={{ display: "flex", margin: 'auto', justifyContent: "center" }}>
                <button
                  className="button is-rounded lightbutton is-success"
                  onClick={() => { localStorage.setItem('saveFilters', JSON.stringify(props.filters)); setManualRender(mr => mr + 1) }}
                  style={{
                    width: "30%",
                    marginRight: "10px"
                  }}
                >
                  Save Filters
                </button>
                <button
                  className="button is-rounded lightbutton"
                  onClick={() => { localStorage.getItem('saveFilters') !== null && props.setFilters(JSON.parse(localStorage.getItem('saveFilters'))); props.setProModalOpen(false); }}
                  style={{
                    width: "30%",
                  }}
                >
                  Load Filters
                </button>
              </div>
              <p style={{ width: "60%", overflowY: "scroll", backgroundColor: "rgba(0,0,0,0.2)", minHeight: manualRender + "px", maxHeight: "10vh", textAlign: "center", margin: "auto", marginTop: "5px" }}>
                {(localStorage.getItem('saveFilters') !== null ?
                  localStorage.getItem('saveFilters') : "").replace("{", "").replace("}", "").replaceAll('"', '').replaceAll(',', ', ').replace("search:,", "").replace("moq:[-1, -1],", "").toLowerCase().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).replace(":", ": ")).join(' ').replaceAll("-1", "N/A")}</p>
            </div>}
          {!props.oos && <br />}
          {!props.oos && <br />}
          {!props.oos && <br />}
          <button
            className="button is-rounded is-danger"
            style={{ fontSize: props.isMobile ? "1.9vh" : ".95vw" }}
            onClick={() => {
              props.setProModalOpen(false);
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ModalForProFeatures;
